<template>
    <div style="margin: 20rpx;">
      <div class="title">隐私政策</div>
      
      <h1>1. 本隐私政策是您与小黑仓APP开发者“杭州觅览电子商务有限公司”（以下简称“开发者”）之间就小黑仓APP提供的服务和信息处理事宜所订立的协议。</h1>
      
      <h1>2. 请您在开始使用我们的服务之前务必审慎阅读本隐私政策各条款，特别是免除或限制责任条款、法律适用条款和争议解决条款。免除或限制责任条款将以粗体标识，请您重点阅读。如果您不接受本隐私政策条款，请立即停止使用服务。如果您对本隐私政策条款有疑问，应向本公司进一步咨询。</h1>
      
      <h1>3. 您的下列行为将被视为您已接受或同意本隐私政策。下列行为一经作出，本隐私政策即构成对双方具有法律约束力的文件:</h1>
      
      <h1>(1) 在小黑仓APP用户界面上向您提供的选择处点击以接受或同意本隐私政策</h1>
      
      <h1>(2) 实际使用小黑仓APP的服务。在此情况下，您理解并同意，本公司视您自使用服务时起接受或同意本隐私政策。</h1>
      
      <h1>4. 开发者处理的信息</h1>
      
      <h1>(1) 为了根据您的位置信息为您提供更契合您需求的页面展示和产品服务，向您推荐精准的导购内容，开发者将在获取您的明示同意后，收集您的位置信息。</h1>
      
      <h1>(2) 为了使您可以使用摄像头进行扫码、拍摄，用于购物、下载图片、直接拍摄并上传图片识别相对应的商品等，开发者将在获取您的明示同意后，使用您的摄像头权限。</h1>
      
      <h1>(3) 为了方便展示您的个人资料，开发者将在获取您的明示同意后，使用您的相册（仅写入）权限。</h1>
      
      <h1>(4) 为了方便展示您的个人资料，开发者将在获取您的明示同意后，收集您的微信昵称、头像。</h1>
      
      <h1>(5) 为了更快捷地通过手机号登录以及填写地址信息，开发者将在获取您的明示同意后，收集您的手机号。</h1>
      
      <h1>(6) 开发者收集您的地址，用于收货地址的快速导入。</h1>
      
      <h1>(7) 开发者收集您选中的照片或视频信息，用于头像或商品图片上传。</h1>
      
      <h1>(8) 开发者读取您的剪切板，用于更加快捷地复制商品信息以及相关地址等文本。</h1>
      
      <h1>5. 您的权益</h1>
      
      <h1>(1) 位置信息和相册权限</h1>
      
      <h1>您可以通以下路径撤回对开发者的授权：APP设置—权限管理—点击特定信息—点击“不允许”。</h1>
      
      <h1>(2) 手机号</h1>
      
      <h1>您可以通过以下路径请求删除您的手机号：APP设置—账户与安全—点击特定信息—点击“删除信息”，开发者承诺收到通知后将删除信息。法律法规另有规定的，开发者承诺将停止除存储和采取必要的安全保护措施之外的处理。</h1>
      
      <h1>(3) 个人信息管理</h1>
      
      <h1>关于您的个人信息，您可以通过以下方式与开发者联系，行使查阅、复制、更正、删除等法定权利：</h1>
      
      <h1>- 微信: HiLuxGoods</h1>
      <h1>- 客服电话: 18667190208</h1>
      
      <h1>(4) 账号注销</h1>
      
      <h1>若您在APP中注册了账号，您可以通过以下方式与开发者联系，申请注销您在APP中使用的账号。在受理您的申请后，开发者承诺在十五个工作日内完成核查和处理，并按照法律法规要求处理您的相关信息。</h1>
      
      <h1>- 微信: HiLuxGoods</h1>
      <h1>- 客服电话: 18667190208</h1>
      
      <h1>6. 开发者对信息的存储</h1>
      
      <h1>开发者承诺，除法律法规另有规定外，开发者对您的信息的保存期限应当为实现处理目的所必要的最短时间。</h1>
      
      <h1>7. 信息的使用规则</h1>
      
      <h1>开发者将会在本隐私政策所明示的用途内使用收集的信息。</h1>
      
      <h1>如开发者使用您的信息超出本隐私政策目的或合理范围，开发者必须在变更使用目的或范围前，再次以短信方式告知并征得您的明示同意。</h1>
      
      <h1>8. 信息对外提供</h1>
      
      <h1>开发者承诺，不会主动共享或转让你的信息至任何第三方，如存在确需共享或转让时，开发者应当直接征得或确认第三方征得您的单独同意。</h1>
      
      <h1>开发者承诺，不会对外公开披露您的信息，如必须公开披露时，开发者应当向您告知公开披露的目的、披露信息的类型及可能涉及的信息，并征得您的单独同意。</h1>
      
      <h1>9. 投诉与建议</h1>
      
      <h1>若您认为开发者未遵守上述约定，或有其他的投诉建议、或未成年人个人信息保护相关问题，您可以通过以下方式与开发者联系；或者向相关监管机构进行投诉。</h1>
      
      <h1>- 微信: HiLuxGoods</h1>
      <h1>- 客服电话: 18667190208</h1>

      <h1>我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。（DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html）</h1>
      
      <h1>10. 更新与生效日期</h1>
      
      <h1>更新日期：2024年10月25日</h1>
      <h1>生效日期：2024年10月25日</h1>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PrivacyPolicy'
  }
  </script>
  
  <style lang="less">
  page {
    background-color: #ffffff;
    line-height: 50rpx;
  }
  .title {
    font-weight: bold;
    font-size: 34rpx;
    text-align: center;
    margin-bottom: 20rpx;
  }
  h1 {
    font-size: 28rpx;
    color: #333333;
    margin: 10rpx 0;
  }
  </style>


// WEBPACK FOOTER //
// src/components/privacy.vue